import { format } from 'date-fns';
import { useEffect, useMemo } from 'react';
import { PageContent } from '~/components/ui/layout/page/PageContent';
import { BasicPage } from '~/components/ui/layout/page/basic/BasicPage';
import { getTaskEntries } from '~/lib/workflows/getTaskEntries';
import { useSingleWorkflow } from '~/lib/workflows/useSingleWorkflow';
import { AgentConversation } from './AgentConversation';
import { WorkflowDetailsPanel } from './WorkflowDetailsPanel';
import { WorkflowHeader } from './WorkflowHeader';

export type SingleWorkflowViewProps = {
  workflowId: string;
};

export const SingleWorkflowView = ({ workflowId }: SingleWorkflowViewProps) => {
  const {
    workflow: selectedWorkflow,
    isLoading,
    agentEvents,
  } = useSingleWorkflow(workflowId);

  // Debug log to see all agent events
  useEffect(() => {
    if (agentEvents && agentEvents.length > 0) {
      console.log('All agent events from hook:', agentEvents);
      // Count events by type
      const eventCounts = agentEvents.reduce(
        (counts, event) => {
          counts[event.event_name] = (counts[event.event_name] || 0) + 1;
          return counts;
        },
        {} as Record<string, number>,
      );
      console.log('Event counts by type:', eventCounts);
    }
  }, [agentEvents]);

  // Get task entries using the utility function
  const taskEntries = useMemo(() => {
    if (!selectedWorkflow) {
      return [];
    }

    return getTaskEntries([selectedWorkflow]);
  }, [selectedWorkflow]);

  const formattedDate = selectedWorkflow
    ? format(new Date(selectedWorkflow.started_at), 'MMM d, yyyy')
    : '';

  console.log('taskEntries', taskEntries);
  console.log('agentEvents', agentEvents);

  return (
    <BasicPage title="Workflows">
      <WorkflowHeader selectedWorkflow={selectedWorkflow} loading={isLoading} />

      <PageContent classes="overflow-hidden mt-2">
        <div
          className="flex flex-direction-row"
          style={{
            height: 'calc(100vh - 8rem)',
            width: '100%',
            columnGap: '0.5rem',
          }}
        >
          <div className="flex flex-column" style={{ width: '50%' }}>
            <div
              className="flex flex-column h-full"
              style={{
                borderRadius: '8px',
                backgroundColor: '#3E3E3E',
              }}
            >
              <div
                className="p-3 border-bottom-1"
                style={{ borderColor: '#333' }}
              >
                <h3 className="mt-0 mb-2" style={{ color: 'white' }}>
                  {selectedWorkflow ? (
                    <>
                      {formattedDate} -{' '}
                      {selectedWorkflow.data.subject ||
                        selectedWorkflow.title ||
                        'Untitled'}
                    </>
                  ) : (
                    'Select a workflow'
                  )}
                </h3>
                {selectedWorkflow && (
                  <p className="text-sm text-color-secondary m-0">
                    From:{' '}
                    {selectedWorkflow.data.from_address || 'Unknown sender'}
                  </p>
                )}
              </div>

              <div className="flex-1 overflow-auto p-3">
                <AgentConversation events={agentEvents} tasks={taskEntries} />
              </div>
            </div>
          </div>

          <div className="flex flex-column" style={{ width: '50%' }}>
            <WorkflowDetailsPanel
              selectedWorkflow={selectedWorkflow}
              taskEntries={taskEntries}
              isLoading={isLoading}
            />
          </div>
        </div>
      </PageContent>
    </BasicPage>
  );
};
